// Sign Up page (.tp-signup) — free-session form: client-side validation +
// success state. Email + phone are format-validated; the phone auto-formats to
// +1 (023) 456-7890 as you type (matches the home lead form).
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-signup');
    if (!root) {
        return;
    }
    var form = root.querySelector('.cs-form');
    if (!form) {
        return;
    }

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var PHONE_RE = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

    function formatPhone(val) {
        var digits = val.replace(/\D/g, '');
        if (digits.length > 0 && digits[0] === '1') {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        if (!digits) {
            return '';
        }
        var r = '+1 (' + digits.slice(0, 3);
        if (digits.length > 3) { r += ') ' + digits.slice(3, 6); }
        if (digits.length > 6) { r += '-' + digits.slice(6, 10); }
        return r;
    }

    var first = form.querySelector('[name="first_name"]');
    var last = form.querySelector('[name="last_name"]');
    var email = form.querySelector('[name="email"]');
    var phone = form.querySelector('[name="phone"]');
    var info = form.querySelector('[name="info"]');
    var errEl = form.querySelector('.cs-error');
    var submit = form.querySelector('.cs-form__submit');
    var reset = form.querySelector('.cs-form__reset');
    var nameTarget = form.querySelector('[data-name-target]');

    function showErr(msg) {
        if (errEl) {
            errEl.textContent = msg;
            errEl.style.display = 'block';
        }
    }

    // Капча: с 5-й заявки с одного IP сервер отвечает арифметическим
    // вопросом — вставляем поле перед блоком ошибки.
    function showCaptcha(captcha) {
        var field = form.querySelector('.js-captcha');
        if (!field) {
            field = document.createElement('label');
            field.className = 'cs-field js-captcha';
            field.innerHTML = '<span class="cs-label js-captcha-q"></span>' +
                '<input class="cs-input" type="text" name="captcha_answer" inputmode="numeric" autocomplete="off" placeholder="Answer"/>' +
                '<input type="hidden" name="captcha_token"/>';
            var anchor = errEl || submit;
            anchor.parentNode.insertBefore(field, anchor);
        }
        field.querySelector('.js-captcha-q').textContent = 'Quick check: ' + captcha.question + ' = ?';
        field.querySelector('[name="captcha_token"]').value = captcha.token;
        var ans = field.querySelector('[name="captcha_answer"]');
        ans.value = '';
        ans.focus();
    }
    function clearErr() {
        if (errEl) {
            errEl.textContent = '';
            errEl.style.display = 'none';
        }
    }

    [first, last, email, phone, info].forEach(function (el) {
        if (el) {
            el.addEventListener('input', clearErr);
        }
    });

    // Green highlight once a field holds a valid value.
    function markValid(el) {
        if (!el) { return; }
        var v = (el.value || '').trim();
        var ok;
        if (el.type === 'email') { ok = EMAIL_RE.test(v); }
        else if (el.name === 'phone') { ok = v !== '' && PHONE_RE.test(v); }
        else { ok = v !== ''; }
        el.classList.toggle('is-valid', ok);
    }
    form.querySelectorAll('.cs-input, .cs-textarea').forEach(function (el) {
        el.addEventListener('input', function () { markValid(el); });
        el.addEventListener('blur', function () { markValid(el); });
    });

    // Live phone formatting.
    if (phone) {
        phone.addEventListener('input', function () {
            var pos = phone.selectionStart;
            var oldLen = phone.value.length;
            phone.value = formatPhone(phone.value);
            var delta = phone.value.length - oldLen;
            phone.setSelectionRange(pos + delta, pos + delta);
        });
    }

    if (submit) {
        submit.addEventListener('click', function (e) {
            e.preventDefault();
            if (!first || !first.value.trim() || !last || !last.value.trim()) {
                showErr('Please enter your first and last name.');
                return;
            }
            if (!email || !EMAIL_RE.test(email.value.trim())) {
                showErr('Please enter a valid email address.');
                return;
            }
            if (!phone || !PHONE_RE.test(phone.value.trim())) {
                showErr('Please enter a valid phone number so we can reach you.');
                return;
            }
            clearErr();
            submit.disabled = true;

            var honeypot = form.querySelector('[name="company_website"]');
            var params = new URLSearchParams();
            params.set('action', 'contact_form_submit');
            params.set('contact_nonce', (window.appVars && window.appVars.nonce) || '');
            params.set('first_name', first.value.trim());
            params.set('last_name', last.value.trim());
            params.set('email', email.value.trim());
            params.set('phone', phone.value.trim());
            params.set('goal', info ? info.value.trim() : '');
            params.set('company_website', honeypot ? honeypot.value : '');
            params.set('page_url', window.location.href);

            var capToken = form.querySelector('[name="captcha_token"]');
            var capAnswer = form.querySelector('[name="captcha_answer"]');
            if (capToken && capToken.value) {
                params.set('captcha_token', capToken.value);
                params.set('captcha_answer', capAnswer ? capAnswer.value.trim() : '');
            }

            // Таймаут: если запрос завис (защита хостинга, сеть), кнопка не
            // должна остаться disabled навсегда — иначе форма «не реагирует».
            var ctrl = new AbortController();
            var timer = setTimeout(function () { ctrl.abort(); }, 15000);

            fetch((window.appVars && window.appVars.ajaxurl) || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: params,
                signal: ctrl.signal
            })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (data && data.success) {
                        window.location.href = (window.appVars && window.appVars.thankYouUrl) || '/thank-you/';
                    } else {
                        submit.disabled = false;
                        if (data && data.data && data.data.captcha) {
                            showCaptcha(data.data.captcha);
                        }
                        showErr((data && data.data && data.data.message) || 'Something went wrong. Please try again.');
                    }
                })
                .catch(function () {
                    submit.disabled = false;
                    showErr('Something went wrong. Please try again.');
                })
                .finally(function () {
                    clearTimeout(timer);
                });
        });
    }

    if (reset) {
        reset.addEventListener('click', function () {
            form.querySelectorAll('input, textarea').forEach(function (el) {
                el.value = '';
            });
            clearErr();
            root.classList.remove('is-sent');
        });
    }
});
